module.exports = __webpack_public_path__ + "static/media/almqr.4b9f302e.webp";